module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"PrintaPhotie SA web","displayName":"FUJIFILM PrintaPhotie","short_name":"PrintaPhotieSAweb","crossOrigin":"use-credentials","start_url":"/","background_color":"#2AAAE1","theme_color":"#2AAAE1","display":"minimal-ui","icon":"static/images/cache/3e6d0370206ea788730f6ce21c6a74e5.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"f9d540551393597313c2a68ac575baf5"},
    },{
      plugin: require('../node_modules/gatsby-plugin-loadable-components-ssr/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[],"excludePattern":"(excluded-link|external)"},
    },{
      plugin: require('../node_modules/@chakra-ui/gatsby-plugin/gatsby-browser.js'),
      options: {"plugins":[],"resetCSS":true,"isUsingColorMode":true},
    },{
      plugin: require('../node_modules/@sentry/gatsby/gatsby-browser.js'),
      options: {"plugins":[],"release":"6.1.1-6062","dsn":"https://4825e17abd8d434897c5061d1be577bb@o149892.ingest.sentry.io/5590009","environment":"production"},
    },{
      plugin: require('../node_modules/gatsby-plugin-ts-config/gatsby-browser.js'),
      options: {"plugins":[],"configDir":"./gatsby-config/","babel":{"plugins":[["/app/builder-v2/webapp/node_modules/babel-plugin-module-resolver/lib/index.js",{"root":["/app/builder-v2/webapp"],"alias":{"~":"./src"}}]]}},
    }]
